/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ahmed Farag",
  description:
    "Full-Stack Software Engineer & Performance Optimization Specialist. GUC Graduate & TUM Researcher with a passion for scalable distributed systems.",
  og: {
    title: "Ahmed Farag Portfolio",
    type: "website",
    url: "http://ahmedhossamfarag.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Ahmed Farag",
  logo_name: "AhmedFarag",
  nickname: "",
  subTitle:
    "Full-Stack Software Engineer & Performance Optimization Specialist. GUC Graduate & TUM Researcher with a passion for scalable distributed systems.",
  resumeLink: "",
  portfolio_repository: "https://github.com/ahmedhossamfarag",
  githubProfile: "https://github.com/ahmedhossamfarag",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ahmedhossamfarag",
  // linkedin: "https://www.linkedin.com/in/ahmed-farag-508541310",
  // gmail: "ahmdhsammfarge@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/ahmedhossamfarag",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ahmed-farag-508541310",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:ahmdhsammfarge@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "X-Twitter",
  //   link: "https://twitter.com/ashutosh_1919",
  //   fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
  //   backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  // },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building scalable, production-ready web applications using React, Next.js, and Laravel",
        "⚡ Architecting complex backend systems with Ruby on Rails, Django, and ASP.NET",
        "⚡ Developing high-performance cross-platform mobile apps using Flutter and Firebase",
      ],
      softwareSkills: [
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: { color: "#000000" },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
          style: { color: "#FF2D20" },
        },
        {
          skillName: "Ruby on Rails",
          fontAwesomeClassname: "simple-icons:rubyonrails",
          style: { color: "#CC0000" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: { color: "#02569B" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: { backgroundColor: "#000000", color: "#F7DF1E" },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: { color: "#339933" },
        },
      ],
    },
    {
      title: "Performance & Systems Research",
      fileName: "DataScienceImg", // Re-using this asset for your TUM Research focus
      skills: [
        "⚡ Optimizing performance-critical modules using hybrid Python and C++ implementations",
        "⚡ Applying advanced graph algorithms and clustering for large-scale data analysis",
        "⚡ Designing isolated environments using schema-based multi-tenancy for SaaS platforms",
      ],
      softwareSkills: [
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: { color: "#00599C" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:openjdk",
          style: { color: "#E76F00" },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "simple-icons:csharp",
          style: { color: "#239120" },
        },
        {
          skillName: "MATLAB",
          fontAwesomeClassname: "simple-icons:mathworks",
          style: { color: "#0076A8" },
        },
      ],
    },
    {
      title: "Cloud & Infrastructure",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Architecting cloud-native solutions using AWS (Lambda, S3, EC2) and Firebase",
        "⚡ Implementing secure multi-tenant architectures and payment integrations via Stripe",
        "⚡ Managing relational and NoSQL databases like PostgreSQL and MySQL for high availability",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: { color: "#FFCA28" },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: { color: "#336791" },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: { color: "#47A248" },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#1488C6" },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: { color: "#2088FF" },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    // {
    //   siteName: "LeetCode",
    //   iconifyClassname: "simple-icons:leetcode",
    //   style: {
    //     color: "#F79F1B",
    //   },
    //   profileLink: "https://leetcode.com/layman_brother/",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "German University in Cairo (GUC)",
      subtitle: "B.Sc. in Information Engineering and Technology",
      logo_path: "guc_logo.png",
      alt_name: "GUC",
      duration: "2021 - 2026",
      descriptions: [
        "⚡ GPA: 0.87/1.0 (German Scale A+ Equivalent).",
        "⚡ Focused on Communication Major with deep dives into Distributed Systems.",
        "⚡ Expertly utilized MATLAB and Python for complex system modeling, signal processing, and numerical simulations.",
        "⚡ Developed high-performance, object-oriented applications using Java, adhering to industry-standard design patterns.",
        "⚡ Completed a rigorous curriculum covering algorithms, data structures, and computer architecture.",
      ],
      website_link: "https://www.guc.edu.eg/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Web Development",
      subtitle: "- Udacity",
      logo_path: "udacity_logo.png",
      certificate_link:
        "www.udacity.com/certificate/e/40cb3afe-8078-11ed-a903-c713c727de09",
      alt_name: "Udacity",
      color_code: "#FFFFFF",
    },
    {
      title: "Web Development",
      subtitle: "- A+ Consultancy",
      logo_path: "a_plus_logo.jpg",
      certificate_link: "",
      alt_name: "A+ Consultancy",
      color_code: "#FFFFFF",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Research, Software Engineering & Volunteering",
  description:
    "I specialize in building production-grade web and mobile applications with a heavy focus on backend architecture and system performance. From developing high-performance simulation engines at TUM to architecting, multi-tenant SaaS platforms, I enjoy solving complex engineering challenges that require both speed and scalability.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Bachelor Thesis Researcher",
          company: "Technische Universität München (TUM)",
          company_url: "https://www.tum.de/en/",
          logo_path: "tum_logo.jpg",
          duration: "5 Months",
          location: "Munich, Germany",
          description:
            "Developed a Python-C++ tool to simulate large digital circuits at gate and transistor levels for aging analysis. Integrated C++ for performance-critical components, achieving up to 10× speed improvements. Applied graph algorithms, clustering, and optimization to assess circuit reliability.",
          color: "#000000",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Web Development Intern",
          company: "YLLAAA",
          company_url: "",
          logo_path: "yllaaa_logo.png",
          duration: "1 Month",
          location: "Work From Home",
          description:
            "Handled both front-end and back-end development for web applications, ensuring high performance and a smooth user experience. Developed strong expertise in modern web technologies, particularly Next.js and NestJS, staying aligned with current industry practices.",
          color: "#ee3c26",
        },
        {
          title: "Web Development Intern (Wix)",
          company: "A+ Consultancy",
          company_url: "",
          logo_path: "a_plus_logo.jpg",
          duration: "2 Months",
          location: "Work From Home",
          description:
            "Developed and maintained Wix CMS-driven pages, implementing dynamic functionality with Velo. Worked closely with the content team to publish and organize blog posts and website content.",
          color: "#ff9900",
        },
        {
          title: "Web Development Intern",
          company: "ADollarClass",
          company_url: "",
          logo_path: "adollarclass_logo.jpg",
          duration: "1 Month",
          location: "Work From Home",
          description:
            "Contributed to developing responsive React components and improving user workflows. Integrated Firebase services for data handling while collaborating closely within an agile team.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Volunteer Flutter Developer",
          company: "Lulllitcloud",
          company_url: "",
          logo_path: "lulllitcloud_logo.jpg",
          duration: "1 Month",
          location: "Work From Home",
          description:
            "Delivered final production-ready Flutter application to employer, ensuring stability, performance, and release quality. Implemented scalable state management, dynamic theming, localization, and background notification handling. Conducted testing, debugging, and performance validation prior to final deployment handoff.",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects leverage a diverse range of modern frameworks and cloud infrastructures to solve real-world problems. I specialize in architecting multi-tenant SaaS platforms, high-performance simulation engines, and cross-platform mobile applications, with a focus on clean code and system scalability.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "neuro-symbolic-sudoku-solver",
    //   name: "Neuro-Symbolic Sudoku Solver",
    //   createdAt: "2023-07-02T00:00:00Z",
    //   description: "Paper published in KDD KiML 2023",
    //   url: "https://arxiv.org/abs/2307.00653",
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile_image.png",
    description:
      "I am available on multiple social media platforms and professional freelance networks. Whether you want to discuss a large-scale system architecture, a custom web solution, or a performance optimization project, I am here to help. I typically respond within 24 hours and specialize in Full-Stack Web, Mobile, and Cloud-Native Development.",
  },
  blogSection: {
    title: "",
    subtitle: "",
    link: "",
    avatar_image_path: "",
  },
  addressSection: {
    title: "",
    subtitle: "",
    locality: "",
    country: "",
    region: "",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "",
    location_map_link: "",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
